export const februaryUppercase = "jra";
export default {februaryUppercase};